import React from "react";

interface RoutedIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string | number;
}

const RoutedIcon: React.FC<RoutedIconProps> = ({
  className = "",
  width = 16,
  height = 16,
  fill = "#FFF9C4",
  fillOpacity,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.6667 10.12V4.66667C12.6667 3.19333 11.4733 2 10 2C8.52667 2 7.33333 3.19333 7.33333 4.66667V11.3333C7.33333 12.0667 6.73333 12.6667 6 12.6667C5.26667 12.6667 4.66667 12.0667 4.66667 11.3333V5.88C5.44 5.6 6 4.86667 6 4C6 2.89333 5.10667 2 4 2C2.89333 2 2 2.89333 2 4C2 4.86667 2.56 5.6 3.33333 5.88V11.3333C3.33333 12.8067 4.52667 14 6 14C7.47333 14 8.66667 12.8067 8.66667 11.3333V4.66667C8.66667 3.93333 9.26667 3.33333 10 3.33333C10.7333 3.33333 11.3333 3.93333 11.3333 4.66667V10.12C10.56 10.3933 10 11.1267 10 12C10 13.1067 10.8933 14 12 14C13.1067 14 14 13.1067 14 12C14 11.1333 13.44 10.4 12.6667 10.12Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default RoutedIcon;
